import { FC } from "react";
import { Navigate } from "react-router-dom";

const HomePage: FC = () => {
  // REDIRECT TO SMART DEVICES
  return <Navigate to={`./devices${window.location.search}`} />;
};

export default HomePage;
